import type { AppointmentListItem, Holiday, HourRow } from './api';
import type { Range } from './time-grid';
import { minutesOfDay, timeToMin, weekdayOf } from './time';

export function openRanges(rows: HourRow[], date: string): Range[] {
  const wd = weekdayOf(date);
  return rows
    .filter((r) => r.weekday === wd)
    .map((r) => ({ start: timeToMin(r.opensAt), end: timeToMin(r.closesAt) }))
    .sort((a, b) => a.start - b.start);
}

/** Trechos fechados (fora do expediente ou feriado) dentro da janela visível. */
export function closedRanges(date: string, rows: HourRow[], holidays: Holiday[], branchId: string | undefined, startMin: number, endMin: number): Range[] {
  if (holidays.some((h) => h.date === date && (h.branchId === null || h.branchId === branchId))) return [{ start: startMin, end: endMin }];
  const open = openRanges(rows, date);
  const out: Range[] = [];
  let cursor = startMin;
  for (const o of open) {
    if (o.start > cursor) out.push({ start: cursor, end: Math.min(o.start, endMin) });
    cursor = Math.max(cursor, o.end);
  }
  if (cursor < endMin) out.push({ start: cursor, end: endMin });
  return out.filter((r) => r.end > r.start);
}

/** Janela visível: expediente da semana ampliado para caber qualquer agendamento. */
export function gridBounds(rows: HourRow[], events: AppointmentListItem[], tz: string): { startMin: number; endMin: number } {
  let start = rows.length ? Math.min(...rows.map((r) => timeToMin(r.opensAt))) : 8 * 60;
  let end = rows.length ? Math.max(...rows.map((r) => timeToMin(r.closesAt))) : 20 * 60;
  for (const e of events) {
    start = Math.min(start, minutesOfDay(e.startsAt, tz));
    end = Math.max(end, minutesOfDay(e.endsAt, tz) || 24 * 60);
  }
  return { startMin: Math.max(0, Math.floor(start / 60) * 60), endMin: Math.min(24 * 60, Math.ceil(end / 60) * 60) };
}
